import LoadScene from '@scenes/LoadScene';
import StartScene from '@scenes/StartScene';
import GameScene from '@scenes/GameScene';
import LV2StartScene from '@scenes/LV2StartScene';
import LV2GameScene from '@scenes/LV2GameScene';
import LV2EndScene from '@scenes/LV2EndScene';

export default [
  { key: 'LoadScene', scene: LoadScene, autoStart: true },
  { key: 'StartScene', scene: StartScene },
  { key: 'GameScene', scene: GameScene },
  { key: 'LV2StartScene', scene: LV2StartScene },
  { key: 'LV2GameScene', scene: LV2GameScene },
  { key: 'LV2EndScene', scene: LV2EndScene },
];
